if (typeof window !== 'undefined') {
	require.ensure([], require => {
		const tns = require('tiny-slider/src/tiny-slider.module').tns;

		((elements, placeholder, controls, nav, i) => {
			for (i = 0; i < elements.length; i++) {
				const items = elements[i].dataset.items;
				const options = {
					container: elements[i].querySelector(placeholder),
					controlsContainer: elements[i].querySelector(controls),
					//navContainer: elements[i].querySelector(nav),
					//nav: true,
					slideBy: 'page',
					mode: elements[i].dataset.mode,
					autoplay: elements[i].dataset.autoplay,
					autoplayTimeout: 6000
				}

				if (items && items > 1) {
					tns(Object.assign({}, options, {
						gutter: elements[i].dataset.gutter,
						responsive: {
							480: {
								items: 1,
							},
							569: {
								items: 2
							},
							960: {
								items: items
							}
						}
					}));
				} else {
					tns(options);
				}
			}
		})(document.querySelectorAll('.slider'), '.slider__placeholder', '.slider__controls', '.slider__nav', 0);
	});
}



// WEBPACK FOOTER //
// ./src/components/slider/slider.js